import Vue from 'vue'
import Vuelidate from 'vuelidate'
import sugar from 'sugar'

sugar.extend()

import App from './App'
import Vuetify from 'vuetify'
import router from './router'
import store from './store'

import locales from './locales'

import '@/assets/styles/index.scss'
import 'vuetify/dist/vuetify.min.css'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'

Vue.config.productionTip = false

Vue.use(Vuetify, {
	lang: {
		locales
	}
})
Vue.use(Vuelidate)

Vue.filter('extendAddress', (address) => {
	const props = ['street', 'houseNumber', 'name', 'district', 'city']

	return Object.assign({
		description: props.map(it => address[it]).filter(it => !!it).unique().join(', '),
		...address
	})
})

new Vue({
	el: '#app',
	router,
	store,
	render: h => h(App)
})
